module.exports = __webpack_public_path__ + "static/media/check-gray.d7b94d5e.svg";